import type { PortalStrings } from "./en";

export const pt: PortalStrings = {
  shell: {
    portal: "Portal do cliente",
    nav: {
      home: "Início",
      case: "Meu caso",
      caseShort: "Caso",
      tasks: "Tarefas",
      documents: "Documentos",
      profile: "Meu perfil",
      profileShort: "Perfil"
    },
    signOut: "Sair",
    language: "Idioma",
    previewing:
      "Você está vendo o portal de {{name}} como o cliente vê. Somente leitura: nada aqui é salvo ou enviado.",
    exitPreview: "Sair da prévia",
    privacy: "Só você e sua equipe jurídica podem ver as suas informações.",
    notClient: "Esta conta não tem um portal do cliente",
    notClientBody:
      "Peça à sua equipe jurídica para convidar você, ou entre com o e-mail que recebeu o convite.",
    useDifferentEmail: "Usar outro e-mail",
    cantPreview: "Não é possível ver a prévia deste portal",
    loadFailed:
      "Não conseguimos carregar o seu portal. Tente novamente em instantes.",
    retry: "Tentar novamente"
  },
  greeting: {
    morning: "Bom dia, {{name}}",
    afternoon: "Boa tarde, {{name}}",
    evening: "Boa noite, {{name}}",
    withTasks_one: "Esta é a única coisa de que precisamos de você.",
    withTasks_other: "Isto é o que precisamos de você.",
    stageLine: {
      started: "O seu caso está a começar.",
      gathering: "Estamos a reunir as informações para o seu caso.",
      review: "O seu advogado está a rever o seu caso.",
      filed: "O seu caso foi apresentado ao USCIS.",
      decision: "O seu caso está na fase de decisão."
    },
    allCaughtUp:
      "Está tudo em dia. Avisaremos quando precisarmos de alguma coisa."
  },
  tasks: {
    title: "O que precisamos de você",
    count_one: "1 tarefa",
    count_other: "{{count}} tarefas",
    none: "Nada por enquanto",
    noneBody:
      "Quando sua equipe jurídica precisar de algo de você, vai aparecer aqui.",
    progress: "{{answered}} de {{total}} respondidas",
    minutesLeft_one: "falta cerca de 1 minuto",
    minutesLeft_other: "faltam cerca de {{count}} minutos",
    due: "prazo: {{date}}",
    dueToday: "prazo: hoje",
    overdue: "o prazo era {{date}}",
    changesRequested:
      "Sua equipe jurídica pediu que você atualize algumas respostas",
    start: "Começar",
    continue: "Continuar",
    update: "Atualizar respostas",
    opening: "Abrindo…",
    openFailed:
      "Não conseguimos abrir esta tarefa. Use o link do seu e-mail ou tente novamente.",
    previewOnly: "As tarefas só abrem para o cliente.",
    sign: "Revisar e assinar",
    ink: "Começar",
    notYet: "Ainda não",
    signMeta: "Cerca de {{minutes}} minutos",
    inkMeta:
      "Imprimir, assinar à caneta e enviar uma foto · cerca de {{minutes}} minutos",
    upcoming: "Abre quando estiver pronto para a sua assinatura",
    sendAgain: "Sua equipe jurídica pediu que você envie de novo"
  },
  case: {
    title: "Seu caso",
    titlePlural: "Seus casos",
    fullTimeline: "Linha do tempo completa",
    now: "O que está acontecendo agora",
    onHold:
      "Seu caso está pausado por enquanto. Sua equipe jurídica avisará quando ele for retomado.",
    approved: "Aprovado",
    decision: "Decisão tomada",
    receipts: "Recibos do USCIS",
    noReceipts:
      "O seu número de recibo aparecerá aqui quando o USCIS enviá-lo.",
    checkStatus: "Consultar status no USCIS",
    checking: "Consultando…",
    checkedAt: "Consultado {{when}}",
    statusFailed:
      "O USCIS não está respondendo agora. Tente novamente mais tarde.",
    details: "Detalhes do caso",
    caseType: "Tipo de caso",
    opened: "Aberto em",
    priorityDate: "Data de prioridade",
    updates: "Novidades",
    noUpdates: "As novidades sobre o seu caso aparecerão aqui.",
    none: "Ainda não há casos",
    noneBody:
      "Quando sua equipe jurídica abrir o seu caso, você poderá acompanhá-lo aqui.",
    back: "Todos os casos",
    notFound: "Não encontramos este caso.",
    step: "Etapa {{n}} de {{total}}",
    startedOn: "iniciado em {{date}}",
    nowChip: "Agora",
    waitingOnYou: "Aguardando você",
    open: "Abrir",
    attorney: "Advogado",
    receiptNumber: "Número do recibo",
    receiptLater: "Aparece aqui depois do protocolo",
    priorityLater: "Definida quando o USCIS recebe o pedido",
    questions: "Dúvidas sobre o seu caso?",
    emailLead: "Enviar e-mail para {{name}}"
  },
  milestone: {
    rfe: "O USCIS pediu mais provas (um Pedido de Evidências, RFE). {{lead}} está preparando a resposta e avisará se precisar de algo de você.",
    interview:
      "O USCIS agendou uma entrevista. {{lead}} vai ajudar você a se preparar e dizer o que levar.",
    biometrics:
      "O USCIS está na etapa de biometria: impressões digitais e uma foto em um escritório do USCIS. Leve o aviso de agendamento e um documento com foto."
  },
  stageAbout: {
    started:
      "Sua equipe jurídica abre o seu caso e define o que precisa de você.",
    gathering:
      "Reunimos suas respostas e documentos: quem você é, o seu histórico e as provas de que o seu caso precisa.",
    review:
      "Seu advogado revisa tudo, prepara os formulários e cartas e pode fazer algumas perguntas adicionais.",
    filed:
      "Enviamos o seu caso ao USCIS. O número de recibo aparecerá aqui quando o USCIS enviá-lo, e você poderá consultar o status nesta página.",
    decision:
      "O USCIS aprova o caso, pede mais provas (um Pedido de Evidências) ou o nega. Vamos explicar o que vem a seguir."
  },
  stage: {
    started: "Primeiros passos",
    gathering: "Coleta de informações",
    review: "Revisão do advogado",
    filed: "Protocolado no USCIS",
    decision: "Decisão"
  },
  explainer: {
    yourTeam: "Sua equipe jurídica",
    yourTeamLower: "sua equipe jurídica",
    started:
      "{{lead}} está organizando o seu caso. Tudo o que precisarmos de você aparecerá nesta página.",
    gathering:
      "{{lead}} está reunindo suas respostas e documentos. Quando estiver tudo pronto, {{leadFirst}} revisa tudo e começa a preparar o seu pedido.",
    review:
      "{{lead}} está revisando as suas informações e preparando o seu pedido. Você pode receber algumas perguntas adicionais.",
    filed:
      "O seu caso foi protocolado no USCIS. Normalmente, o USCIS primeiro envia pelo correio um aviso de recebimento e depois pode agendar a coleta de dados biométricos. Os prazos variam conforme o tipo de caso.",
    decision:
      "O USCIS tomou uma decisão sobre o seu caso. {{lead}} vai explicar o que ela significa e os próximos passos."
  },
  updates: {
    opened: "Seu caso foi aberto",
    filed: "Seu caso foi protocolado no USCIS",
    approved: "O USCIS aprovou o seu caso",
    decided: "O USCIS tomou uma decisão sobre o seu caso",
    reopened: "Seu caso foi reaberto",
    receipt: "Recibo do USCIS {{receipt}} adicionado",
    receipt_unnamed: "Um recibo do USCIS foi adicionado",
    questions_sent: "Enviamos perguntas para você responder",
    answers_received: "Recebemos as suas respostas",
    changes_requested: "Pedimos que você atualize algumas respostas",
    answers_reviewed: "Suas respostas foram revisadas"
  },
  comingUp: {
    title: "Em breve",
    taskDue: "Prazo: {{title}}",
    allDay: "Dia inteiro"
  },
  team: {
    title: "Sua equipe jurídica",
    email: "Enviar e-mail para {{name}}"
  },
  reminders: {
    title: "Fique atento",
    expiresIn_one: "{{subject}} vence amanhã",
    expiresIn_other: "{{subject}} vence em {{count}} dias",
    expiresToday: "{{subject}} vence hoje",
    expired: "{{subject}}: a data de vencimento registrada era {{date}}",
    expiresHint:
      "Avise sua equipe jurídica antes de renovar ou de planejar qualquer viagem.",
    expiredHint:
      "Se você recebeu um documento mais recente, envie-o para que sua equipe jurídica o tenha.",
    yours: {
      status: "seu status {{status}}",
      immigration_status_expiration: "seu status migratório",
      i94_expiration: "seu I-94",
      passport_expiration: "seu passaporte",
      ead_expiration: "sua autorização de trabalho (EAD)",
      advance_parole_expiration: "sua autorização de viagem (advance parole)",
      visa_expiration: "seu visto"
    },
    theirs: {
      immigration_status_expiration: "o status migratório de {{name}}",
      i94_expiration: "o I-94 de {{name}}",
      passport_expiration: "o passaporte de {{name}}",
      ead_expiration: "a autorização de trabalho (EAD) de {{name}}",
      advance_parole_expiration:
        "a autorização de viagem (advance parole) de {{name}}",
      visa_expiration: "o visto de {{name}}"
    }
  },
  documents: {
    title: "Documentos",
    subtitle:
      "O que você nos enviou e o que sua equipe jurídica compartilhou com você.",
    upload: "Enviar um documento",
    takePhoto: "Tirar uma foto",
    uploading: "Enviando {{name}}…",
    uploaded: "{{name}} enviado à sua equipe jurídica",
    uploadFailed: "{{name}} não foi enviado. Tente novamente.",
    fromYou: "Enviado por você",
    fromTeam: "Da sua equipe jurídica",
    open: "Abrir",
    remove: "Remover",
    removed: "{{name}} removido",
    removeFailed: "Não foi possível remover. Tente novamente.",
    none: "Ainda não há documentos",
    noneBody:
      "Envie os documentos que sua equipe jurídica pedir, ou volte depois para ver os arquivos compartilhados com você.",
    previewOnly: "Na prévia, o envio de arquivos fica desativado.",
    checking: "Verificando {{name}}…",
    looksGood: "{{name}} parece estar bom",
    weRead: "Foi isto que lemos:",
    mayBeHard: "{{name}} pode estar difícil de ler",
    replace: "Substituir",
    keep: "Manter"
  },
  sign: {
    from: "De {{name}}",
    inkWhy:
      "O USCIS exige assinatura à mão nos formulários em papel, então esta página não pode ser assinada na tela.",
    read: "Leia o documento",
    readHint: "Leia todas as páginas antes de assinar.",
    add: "Adicione sua assinatura",
    draw: "Desenhar",
    type: "Digitar",
    drawHint: "Assine aqui com o dedo ou o mouse",
    clear: "Limpar",
    fullName: "Seu nome completo",
    consent:
      "Concordo em assinar este documento eletronicamente e que minha assinatura eletrônica vale o mesmo que minha assinatura à mão.",
    signAndSend: "Assinar e enviar para {{name}}",
    signing: "Assinando…",
    audit:
      "Enviamos uma cópia assinada para o seu e-mail. Sua assinatura, o horário e uma impressão digital do documento ficam registrados para verificação posterior.",
    needSignature: "Primeiro desenhe ou digite sua assinatura.",
    needConsent: "Marque a caixa para concordar com a assinatura eletrônica.",
    failed: "Não foi possível assinar. Tente de novo.",
    signed: "Assinado",
    signedBody:
      "Você assinou em {{date}}. Enviamos uma cópia para o seu e-mail.",
    signedNoCopy: "Você assinou em {{date}}.",
    downloadSigned: "Baixar sua cópia assinada",
    print: "Imprima a página",
    download: "Baixar a página para assinar (PDF)",
    noPrinter:
      "Não tem impressora? Peça à sua equipe jurídica para enviá-la pelo correio.",
    inkSign: "Assine com caneta preta",
    inkBox: "Assine no campo “{{box}}” da página {{page}}.",
    inkBoxPage: "Assine no campo de assinatura da página {{page}}.",
    photo: "Tire uma foto da página assinada",
    photoHint: "Deixe-a plana, com boa luz e com a página inteira visível.",
    takePhoto: "Tirar uma foto",
    chooseFile: "Escolher um arquivo",
    retake: "Tirar de novo",
    checking: "Verificando sua foto…",
    found: "Assinatura encontrada no campo",
    notFound: "Não vimos uma assinatura no campo",
    readable: "Página inteira visível e legível",
    notReadable: "Parte da página está difícil de ler",
    unchecked:
      "Não conseguimos verificar esta foto, mas você ainda pode enviá-la.",
    send: "Enviar para {{name}}",
    sendAnyway: "Enviar mesmo assim",
    sending: "Enviando…",
    uploadFailed: "A foto não foi enviada. Tente de novo.",
    keepOriginal:
      "Guarde o original. {{name}} pode pedir que você o envie pelo correio.",
    sent: "Enviado para {{name}}",
    sentBody:
      "{{name}} vai verificar e avisar se precisar de mais alguma coisa. Guarde o original.",
    completed: "Pronto",
    completedBody: "{{name}} aceitou sua página assinada.",
    returned: "{{name}} pediu que você envie de novo:",
    upcoming: "Ainda não está pronto",
    upcomingBody:
      "{{name}} vai avisar quando estiver pronto para a sua assinatura.",
    gone: "Este documento não precisa mais da sua assinatura.",
    back: "Voltar às tarefas",
    previewOnly: "Na prévia, não é possível assinar.",
    viewer: "Documento para assinar",
    changed:
      "Este documento mudou depois de ser enviado. Sua equipe jurídica vai enviá-lo de novo."
  },
  profile: {
    subtitle:
      "Estas são as informações que vão nos seus formulários de imigração. Se algo estiver errado ou tiver mudado, sugira uma correção e {{name}} vai revisá-la.",
    about: "Sobre você",
    contact: "Como falamos com você",
    lived: "Onde você morou",
    worked: "Onde você trabalhou",
    studied: "Sua formação",
    noneOnFile: "Ainda não há nada registrado",
    notOnFile: "Não registrado",
    historyHint: "Falta algo ou há algum erro aqui?",
    tellUs: "Avisar {{name}}",
    suggest: "Sugerir uma correção",
    add: "Adicionar",
    waiting: "Aguardando a revisão de {{name}}",
    withdraw: "Retirar",
    withdrawn: "Sugestão retirada",
    updated: "Atualizado",
    kept: "{{name}} manteve o que estava registrado.",
    keptWhy: "{{name}} manteve o que estava registrado: {{reason}}",
    note: "Algo que {{name}} deva saber?",
    notePlaceholder: "Por exemplo: meu passaporte tem a grafia correta.",
    addressPlaceholder: "Se você se mudou, diga quando.",
    historyLabel: "O que está faltando ou errado?",
    historyPlaceholder:
      "Por exemplo: morei na 12 Elm St, Austin, TX, de junho de 2019 a maio de 2020.",
    yourNotes: "Observações que você enviou",
    attach: "Anexar um documento",
    attachHint: "Uma foto ou PDF que mostre a informação correta.",
    attaching: "Enviando {{name}}…",
    attachFailed: "Esse arquivo não foi enviado. Tente novamente.",
    removeAttachment: "Remover anexo",
    cancel: "Cancelar",
    send: "Enviar para {{name}}",
    sending: "Enviando…",
    sent: "Enviado para {{name}} revisar",
    failed: "Não foi possível enviar. Tente novamente.",
    unchanged: "Isso já é o que temos. Altere algum dado primeiro.",
    previewOnly: "Na prévia, não é possível enviar sugestões.",
    present: "hoje",
    topic: {
      legal_name: "Nome legal",
      other_names: "Outros nomes que você já usou",
      birthday: "Data de nascimento",
      birthplace: "Local de nascimento",
      citizenships: "Cidadania",
      marital_status: "Estado civil",
      email: "E-mail",
      phone: "Telefone",
      physical_address: "Endereço residencial",
      mailing_address: "Endereço para correspondência",
      history: "Seu histórico"
    },
    field: {
      first_name: "Nome",
      middle_name: "Nome do meio",
      last_name: "Sobrenome",
      other_names: "Outros nomes, separados por vírgulas",
      birthday: "Data de nascimento",
      city_of_birth: "Cidade",
      state_of_birth: "Estado ou província",
      country_of_birth: "País",
      citizenships: "Países, separados por vírgulas",
      marital_status: "Estado civil",
      email: "E-mail",
      phone: "Telefone",
      street: "Rua e número",
      city: "Cidade",
      state: "Estado",
      zip_code: "CEP ou código postal",
      country: "País"
    },
    marital: {
      single: "Solteiro(a), nunca se casou",
      married: "Casado(a)",
      divorced: "Divorciado(a)",
      widowed: "Viúvo(a)",
      separated: "Separado(a) judicialmente",
      annulled: "Casamento anulado"
    }
  },
  signIn: {
    title: "Entre no seu portal",
    sentTitle: "Verifique seu e-mail",
    email: "E-mail",
    send: "Enviar link de acesso por e-mail",
    sending: "Enviando…",
    hint: "Não precisa de senha. Enviaremos para este e-mail um link que faz o seu login.",
    sent: "Se {{email}} tiver um portal do cliente, um link de acesso está a caminho. Ele funciona uma única vez e expira em uma hora.",
    sendAnother: "Usar outro e-mail",
    failed: "Não foi possível enviar o link. Tente novamente em um minuto.",
    staff: "Trabalha em um escritório de advocacia?",
    staffLink: "Entre aqui"
  },
  welcome: {
    signingIn: "Entrando…",
    expired: "Este link expirou",
    used: "Este link já foi usado",
    invalid: "Este link não é válido",
    revoked: "Este link não funciona mais",
    off: "O acesso ao portal está desativado",
    offBody: "Peça à sua equipe jurídica para reativá-lo.",
    getNew: "Digite o seu e-mail e enviaremos um novo link de acesso."
  },
  intake: {
    language: "Idioma",
    showEnglish: "Ver em inglês",
    showTranslated: "Ver em {{language}}",
    translating: "Traduzindo as perguntas…",
    translationFailed:
      "Não conseguimos traduzir as perguntas agora, então elas estão em inglês.",
    answerHint:
      "Responda em inglês, se puder. Se não, responda no seu idioma e sua equipe jurídica fará a tradução.",
    defaultNote:
      "Preencha este questionário com calma. Confira se todas as informações correspondem aos seus documentos oficiais.",
    defaultTitle: "Questionário de imigração",
    start: "Começar",
    resume: "Continuar",
    fix_one: "Corrigir {{count}} resposta →",
    fix_other: "Corrigir {{count}} respostas →",
    takes_one: "Leva cerca de {{count}} minuto",
    takes_other: "Leva cerca de {{count}} minutos",
    left_one: "Falta cerca de {{count}} minuto",
    left_other: "Faltam cerca de {{count}} minutos",
    about_one: "Cerca de {{count}} minuto",
    about_other: "Cerca de {{count}} minutos",
    othersSaved_one: " · a outra resposta está salva",
    othersSaved_other: " · as outras {{count}} respostas estão salvas",
    needsChanges_one:
      "Seu advogado revisou suas respostas e precisa de uma alteração.",
    needsChanges_other:
      "Seu advogado revisou suas respostas e precisa de {{count}} alterações.",
    attorney: "Advogado",
    yourAttorney: "Seu advogado",
    yourAttorneyLower: "seu advogado",
    yourFirm: "Seu escritório de advocacia",
    you: "Você",
    welcomeBack: "Que bom ver você de novo",
    welcomeBackName: "Que bom ver você de novo, {{name}}.",
    resumeBody:
      "Você já começou este questionário. Quer continuar de onde parou?",
    continueWhereLeft: "Continuar de onde parei",
    reviewFromStart: "Revisar desde o início",
    ok: "OK",
    skip: "Pular",
    continue: "Continuar",
    submit: "Enviar",
    sendTo: "Enviar para {{name}}",
    yes: "Sim",
    no: "Não",
    previousStep: "Etapa anterior",
    nextStep: "Próxima etapa",
    displaySettings: "Opções de exibição",
    typeAnswer: "Digite sua resposta aqui...",
    yourAnswer: "Sua resposta",
    typeOrSelect: "Digite ou escolha uma opção",
    noMatches: "Nenhuma opção corresponde",
    street: "Endereço",
    city: "Cidade",
    state: "Estado / Província",
    statePlaceholder: "Estado",
    postal: "CEP / Código postal",
    postalPlaceholder: "Código postal",
    country: "País",
    dragDrop: "Arraste e solte seus arquivos",
    uploadingShort: "Enviando...",
    upload: "Enviar",
    uploadMore: "Enviar mais",
    uploadedFiles: "Arquivos enviados",
    uploadingDocument: "Enviando documento",
    uploaded: "Enviado",
    uploadedBody_one: "Seu arquivo foi enviado com sucesso.",
    uploadedBody_other: "{{count}} arquivos enviados com sucesso.",
    someFailed: "Alguns arquivos não foram enviados",
    uploadFailed: "Falha no envio",
    pleaseTryAgain: "Tente novamente.",
    saved: "Salvo",
    savedBody:
      "Você pode fechar esta página e voltar depois usando o mesmo link.",
    couldntSave: "Não foi possível salvar",
    submitted: "Enviado",
    submittedBody: "Suas respostas foram enviadas com sucesso.",
    couldntSubmit: "Não foi possível enviar",
    thankYou: "Obrigado!",
    thankYouBody:
      "Sua equipe jurídica recebeu as suas respostas e vai revisá-las em breve. Você já pode fechar esta aba.",
    review: "Revise suas respostas",
    reviewBody:
      "Revise suas respostas antes de enviar. Você pode alterar o que for preciso.",
    reviewGroupBody:
      "Você pode editar ou remover qualquer item, ou adicionar outro.",
    edit: "Editar",
    remove: "Remover",
    notAnswered: "Sem resposta",
    notProvided: "Não informado",
    noEntries: "Nenhum item.",
    noEntriesAdded: "Nenhum item adicionado.",
    noEntriesYet: "Nenhum item adicionado ainda.",
    noEntriesSubmitted: "Nenhum item foi enviado.",
    noDetails: "Nenhum detalhe informado ainda.",
    noDocChanges: "Nenhuma alteração de documento foi pedida.",
    noDocs: "Nenhum documento disponível.",
    leaveComment: "Deixe um comentário...",
    addComment: "Adicionar um comentário",
    addReply: "Responder",
    cancel: "Cancelar",
    youSent: "Você enviou",
    youAnswered: "Você respondeu:",
    addAnother: "Adicionar outro?",
    loadFailed: "Não foi possível carregar o questionário",
    oops: "Ops, algo deu errado.",
    persists:
      "Se o problema continuar, entre em contato com o seu escritório de advocacia.",
    tryAgain: "Tentar novamente",
    attention_one: "Um arquivo precisa de atenção",
    attention_other: "{{count}} arquivos precisam de atenção",
    attentionBody: "Seu advogado pode pedir que você os envie de novo.",
    sendAnyway: "Enviar mesmo assim",
    savesAuto: "Seu progresso é salvo automaticamente",
    prefilledCount_one: "{{count}} resposta já preenchida",
    prefilledCount_other: "{{count}} respostas já preenchidas",
    progressOf: "{{current}} de {{total}}",
    savedAt: "Salvo {{time}}",
    backToPortal: "Voltar ao seu portal",
    outline: {
      questions_one: "{{count}} pergunta",
      questions_other: "{{count}} perguntas",
      filled_one: "{{count}} preenchida",
      filled_other: "{{count}} preenchidas",
      minutes_one: "{{count}} min",
      minutes_other: "{{count}} min",
      done: "Pronto"
    },
    prefill: {
      ask: "Está correto?",
      yes: "Sim, está correto",
      change: "Alterar",
      fromDocs: "Dos seus documentos",
      onFile: "Já temos registrado"
    },
    date: {
      day: "Dia",
      month: "Mês",
      year: "Ano",
      pickMonth: "Escolha um mês",
      echo: "Você escreveu: {{date}}",
      invalid: "Essa data não existe. Confira o dia e o mês."
    },
    ph: {
      email: "nome@exemplo.com",
      phone: "+1 555 123 4567",
      givenName: "Como aparece no seu passaporte",
      familyName: "Como aparece no seu passaporte",
      middleName: "Deixe em branco se não tiver",
      otherNames: "Outros nomes que você já usou",
      fullName: "Nome completo",
      number: "Como impresso no documento",
      city: "Cidade",
      country: "País",
      employer: "Empresa ou organização",
      jobTitle: "Seu cargo",
      school: "Escola ou universidade",
      website: "https://",
      longText: "Digite sua resposta aqui…",
      answer: "Digite sua resposta aqui…"
    },
    group: {
      tellUs: "Conte-nos sobre: {{name}}.",
      tellUsAddresses: "Conte-nos sobre o seu histórico de endereços.",
      tellUsEmployment: "Conte-nos sobre o seu histórico profissional.",
      tellUsStatuses: "Conte-nos sobre o seu histórico de status migratório.",
      tellUsTrips: "Conte-nos sobre suas entradas e saídas dos EUA.",
      tellUsDependents: "Conte-nos sobre os seus dependentes.",
      leadIn: "Você tem algo a adicionar em: {{name}}?",
      leadInAddresses: "Você tem endereços anteriores para adicionar?",
      leadInEmployment: "Você tem empregos anteriores para adicionar?",
      leadInStatuses: "Você tem status migratórios anteriores para adicionar?",
      leadInTrips: "Você tem entradas ou saídas dos EUA para adicionar?",
      addAnother: "Adicionar outro: {{name}}?",
      addAnotherAddress: "Adicionar outro endereço?",
      addAnotherEmployer: "Adicionar outro empregador?",
      addAnotherStatus: "Adicionar outro status?",
      addAnotherTrip: "Adicionar outra viagem?",
      review: "Revise: {{name}}",
      reviewAddresses: "Revise seus endereços",
      reviewEmployers: "Revise seus empregadores",
      reviewStatuses: "Revise seus status",
      reviewTrips: "Revise suas viagens",
      entries: "itens"
    }
  },
  common: {
    loading: "Carregando…",
    today: "hoje",
    yesterday: "ontem",
    daysAgo_one: "há 1 dia",
    daysAgo_other: "há {{count}} dias"
  }
};
